import { getAuthLoginAddress, login } from '@/api/auth'
import { getUserInfo, savePhoneNumber } from '@/api/user'
import { Toast, Dialog } from 'vant'
import { removeCodeFromUrl } from '@/utils/utils'
const state = {
  loginPath: '', // 点登陆的当前页
  tokenValue: '',
  userInfo: null
}

const mutations = {
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
  },
  SET_TOKEN_VALUE: (state, val) => {
    state.tokenValue = val
  },
  SET_LOGIN_PATH: (state, path) => {
    state.loginPath = path
  }
}

// 集中管理用户信息获取和手机号检查的函数
const checkUserInfoAndPhone = async (commit) => {
  try {
    const response = await getUserInfo()
    if (response.code !== 200) {
      Toast(response.msg || '获取用户信息失败')
      return null
    }
    
    const userInfo = response.user
    commit('SET_USER_INFO', userInfo)
    
    // 获取用户信息成功后，清理URL中的code参数
    removeCodeFromUrl()
    
    // 检查是否有手机号
    if (!userInfo.phonenumber) {
      await showPhoneNumberDialog(commit)
    }
    
    return userInfo
  } catch (error) {
    console.error('获取用户信息失败', error)
    Toast('获取用户信息失败')
    return null
  }
}

// 显示手机号输入对话框
const showPhoneNumberDialog = (commit) => {
  return new Promise((resolve) => {
    Dialog.confirm({
      title: '请输入您的手机号',
      message: '请填写您的手机号码用来接收重要信息',
      showCancelButton: false,
      confirmButtonText: '确定',
      beforeClose: (action, done) => {
        if (action === 'confirm') {
          const phoneInput = document.querySelector('.phone-input-field')
          const phoneNumber = phoneInput ? phoneInput.value : ''
          if (!phoneNumber) {
            Toast('请输入手机号码')
            return
          }
          
          if (!/^1[3-9]\d{9}$/.test(phoneNumber)) {
            Toast('请输入正确的手机号码')
            return
          }
          
          // 调用保存手机号接口
          savePhoneNumber(phoneNumber)
            .then(() => {
              Toast.success('手机号保存成功')
              // 更新用户信息状态
              getUserInfo().then(res => {
                if (res.code === 200) {
                  commit('SET_USER_INFO', res.user)
                  resolve(res.user)
                }
              })
              done()
            })
            .catch(err => {
              Toast.fail(err)
              console.error(err)
              done(false) // 关闭loading但不关闭对话框，允许用户再次提交
            })
        } else {
          done()
          resolve(null)
        }
      }
    }).then(() => {
      // 点击确认按钮后的回调
    })
    
    // 在确认对话框上添加输入框
    setTimeout(() => {
      const dialogContent = document.querySelector('.van-dialog__message')
      if (dialogContent && !dialogContent.querySelector('.phone-input-field')) {
        const inputField = document.createElement('div')
        inputField.style.margin = '20px 0 0'
        inputField.innerHTML = `
          <input 
            type="tel" 
            placeholder="请输入手机号" 
            maxlength="11"
            class="phone-input-field"
            style="width: 100%; height: 40px; border: 1px solid #dcdee0; border-radius: 4px; padding: 0 15px; font-size: 14px; box-sizing: border-box;"
          />
        `
        dialogContent.appendChild(inputField)
      }
    }, 100)
  })
}

const actions = {
  async login({ commit, dispatch }, code) {
    try {
      const { data } = await login(code)
      commit('SET_TOKEN_VALUE', data)
      localStorage.setItem('user_tokenValue', data)
      
      // 登录成功后立即获取用户信息和检查手机号
      await dispatch('fetchUserInfo')
      return data
    } catch (error) {
      Toast(error)
      throw error
    }
  },
  
  // 新的集中管理用户信息的action
  async fetchUserInfo({ commit }) {
    return await checkUserInfoAndPhone(commit)
  },
  
  // 替换原有的checkUserPhoneNumber方法
  async checkUserPhoneNumber({ commit }) {
    return await checkUserInfoAndPhone(commit)
  },
  
  // 替换原有的loadUserInfo方法
  async loadUserInfo({ commit }) {
    return await checkUserInfoAndPhone(commit)
  },
  
  async jumpAuthAddress() {
    try {
      // const url = `${window.location.origin}${window.location.pathname}#/login`
      const url = 'https://tangzong.hucs.top'
      const { data } = await getAuthLoginAddress(url)
      window.location.href = data
    } catch (error) {
      Toast(error)
    }
  },
  set_token_value({ commit }, token) {
    commit('SET_TOKEN_VALUE', token)
  },
  set_user_info({ commit }, info) {
    commit('SET_USER_INFO', info)
  },
  set_login_path({ commit }, path) {
    commit('SET_LOGIN_PATH', path)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
